import { render, staticRenderFns } from "./MailRecords.vue?vue&type=template&id=3b0891a3&scoped=true"
import script from "./MailRecords.vue?vue&type=script&lang=js"
export * from "./MailRecords.vue?vue&type=script&lang=js"
import style0 from "./MailRecords.vue?vue&type=style&index=0&id=3b0891a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0891a3",
  null
  
)

export default component.exports